import { EventBus } from "../../../eventbus";
import i18n from "../../../functions/i18next";

export default {
  data() {
    return {
      id: this.$options.name,
      showWrapper: false,
      doOnce: true,
      statesList: ["reset", "userforget"],
    };
  },
  created() {
    this.openOnEnter();

    EventBus.$on(`${this.id}-open`, () => {
      this.showWrapper = true;
      this.doOnce = false;
    });

    EventBus.$on(`${this.id}-close`, () => {
      this.showWrapper = false;
    });
  },
  methods: {
    openOnEnter() {
      const route = this.$route.path;

      this.statesList.forEach((state) => {
        if (route.includes(state)) {
          this.setShowWrapper(true);
        }
      });
    },
    setShowWrapper(setting = !this.showWrapper) {
      this.showWrapper = setting;
      this.doOnce = false;

      //reset the login menu if needed
      EventBus.$emit("requestAccessButtonReset");
    },
  },
  computed: {
    buttonText() {
      const user = this.$store.state.user;
      if (user) {
        const name = user.name;

        if (name.length > 31) {
          return `${name.substring(0, 30)}...`;
        } else {
          return user.name;
        }
      } else {
        return `${i18n.t("login.login")}`;
      }
    },
  },
};
